import React from "react";

function StatCard({ title, value, icon, badge, subValue, themeColor, iconSize = 48 }) {
  return (
    <div className="bg-white rounded-[2.5rem] p-6 border border-gray-100/60 shadow-[0_8px_30px_rgb(0,0,0,0.03)] relative overflow-hidden group hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] transition-all duration-500 hover:-translate-y-1">
      {/* Glow Effect */}
      <div className={`absolute top-0 right-0 -m-8 w-32 h-32 rounded-full opacity-5 blur-2xl transition-transform duration-700 group-hover:scale-150`}
        style={{ backgroundColor: themeColor }} />

      <div className="relative z-10 flex flex-col justify-between h-full">
        <div className="flex items-center justify-between mb-4">
          <div className="flex flex-col">
            <p className="text-gray-400 text-[10px] sm:text-xs font-black uppercase tracking-widest mb-1">{title}</p>
            <div className="flex items-baseline gap-1.5">
              <h3 className="text-2xl sm:text-3xl font-black text-gray-800 font-do-hyeon leading-none">{value}</h3>
              {subValue && <span className="text-xs font-bold text-gray-400">{subValue}</span>}
            </div>
          </div>
          <div className="p-2.5 rounded-2xl bg-gray-50 flex items-center justify-center border border-gray-100/50">
            <img src={icon} alt={title} className="object-contain" style={{ width: iconSize / 2, height: iconSize / 2 }} />
          </div>
        </div>

        {badge && (
          <div className="mt-2 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-gray-50 border border-gray-100/50">
            <span className="text-[10px] font-black tracking-wide" style={{ color: themeColor }}>{badge}</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default function CounselingStatsSection({
  filteredStudents,
  visitLogs,
  isMobile,
  theme,
  LOCAL_ICONS,
}) {
  const accentColor = theme?.primaryHex || '#354F38';

  const totalVisits = filteredStudents.reduce((acc, student) => {
    const logs = visitLogs.filter((l) => l.studentId === student.id);
    return acc + logs.length;
  }, 0);

  const now = new Date();
  const thisMonthVisits = filteredStudents.reduce((acc, student) => {
    const logs = visitLogs.filter(
      (l) => l.studentId === student.id && new Date(l.date).getMonth() === now.getMonth() && new Date(l.date).getFullYear() === now.getFullYear()
    );
    return acc + logs.length;
  }, 0);

  const visitedStudentsCount = filteredStudents.filter((student) => visitLogs.some((l) => l.studentId === student.id)).length;
  const coverageRate = filteredStudents.length > 0 ? Math.round((visitedStudentsCount / filteredStudents.length) * 100) : 0;

  const typeCounts = {};
  filteredStudents.forEach((student) => {
    visitLogs
      .filter((l) => l.studentId === student.id)
      .forEach((l) => {
        typeCounts[l.type] = (typeCounts[l.type] || 0) + 1;
      });
  });
  const topType = Object.entries(typeCounts).sort((a, b) => b[1] - a[1])[0];

  return (
    <div className={`grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8 ${isMobile ? "p-4 pb-0" : "mt-2"}`}>
      <StatCard
        title="누적 심방"
        value={`${totalVisits}회`}
        icon={LOCAL_ICONS.memo}
        themeColor={accentColor}
        badge="ACCUMULATED"
      />

      <StatCard
        title="이번 달 심방"
        value={`${thisMonthVisits}회`}
        icon={LOCAL_ICONS.sparkles}
        themeColor="#F59E0B"
        badge="THIS MONTH"
      />

      <StatCard
        title="심방 커버리지"
        value={`${coverageRate}%`}
        subValue={`(${visitedStudentsCount}/${filteredStudents.length}명)`}
        icon={LOCAL_ICONS.student}
        themeColor="#3B82F6"
        badge="CARE STATUS"
      />

      <StatCard
        title="주요 소통"
        value={topType ? topType[0] : "-"}
        icon={LOCAL_ICONS.chat}
        themeColor="#8B5CF6"
        badge="PRIMARY METHOD"
      />
    </div>
  );
}
